import { render, staticRenderFns } from "./FooterContact.vue?vue&type=template&id=48005a34&"
import script from "./FooterContact.vue?vue&type=script&lang=js&"
export * from "./FooterContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports